module.exports = __webpack_public_path__ + "img/rejected.f864acdf.svg";